module.exports = __webpack_public_path__ + "img/167-macao.93e1067b.svg";